module.exports = __webpack_public_path__ + "img/light_shape_circle.dda40ddc.svg";